export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('app:rendered', ctx => {
    // キャッシュ無し
    ctx.ssrContext.event.node.res.setHeader(
      'Cache-Control',
      'no-cache, no-store, max-age=0, must-revalidate',
    )
    ctx.ssrContext.event.node.res.setHeader('Expires', '0')
    ctx.ssrContext.event.node.res.setHeader('Pragma', 'no-cache')
  })
})
